// extracted by mini-css-extract-plugin
export var blue = "_45-g";
export var brand = "_45-c";
export var darkGrey = "_45-f";
export var disabled = "_45-6";
export var disabledSubtle = "_45-7";
export var error = "_45-8";
export var green = "_45-h";
export var grey = "_45-e";
export var icon = "_45-0";
export var inherit = "_45-b";
export var lightGrey = "_45-d";
export var orange = "_45-j";
export var pink = "_45-l";
export var primary = "_45-1";
export var purple = "_45-m";
export var quaternary = "_45-4";
export var quinary = "_45-5";
export var red = "_45-k";
export var secondary = "_45-2";
export var success = "_45-a";
export var tertiary = "_45-3";
export var warning = "_45-9";
export var white = "_45-n";
export var yellow = "_45-i";